module.exports = __webpack_public_path__ + "static/img/popbanner_tibe.4cbdd73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/popbanner_tibe.jpg
// module id = ZfwU
// module chunks = 1